/**
 * Configuration parameters for points calculation system
 */

export const POINTS_CONFIG = {
  /**
   * Maximum number of check-ins per day per location that count towards points
   */
  MAX_CHECKINS_PER_DAY_PER_LOCATION: 3,

  /**
   * Points awarded for the first visit to a unique location
   */
  FIRST_VISIT_POINTS: 15,

  /**
   * Points awarded per hour for non-first visits
   */
  POINTS_PER_HOUR: 5,

  /**
   * Bonus points awarded for checking into a bonus location
   */
  BONUS_POINTS: 125,

  /**
   * Bonus points awarded for visiting locations in Spain
   */
  BONUS_POINTS_SPAIN: 75,
} as const;

export type PointsConfig = typeof POINTS_CONFIG;
